import React, {Component} from "react";
import _ from 'i18n';
import EventLineChartLegendRow from "./EventLineChartLegendRow";
import {Button, Col, Row} from "antd";
import {formatAmount, formatNumber} from "../../../../services/utils";
import { connect } from "react-redux";

@connect(store => ({
  auth: store.auth
}))
export default class EventLineChartLegend extends Component {

  calculateRegistrantsNumberByAppType = (appType, chartData) => {
    const {startMonth, endMonth} = this.props;

    if (chartData.length === 0)
      return 0;

    return chartData.reduce(function (tot, record, index) {
      if (!startMonth && !endMonth)
        return tot + record[appType];

      return startMonth <= index + 1 && index + 1 <= endMonth ? tot + record[appType] : tot;
    }, 0);

  }


  render() {
    const { auth } = this.props;
   
    const {
      updateChartLinesToShow,
      chartLinesToShow,
      fetching,
      isError,
      chartData,
      chartDataCA,
      sourceData,
      sourceDataCA,
      year,
      sourceYear,
      type,
      startMonth,
      endMonth,
      frequency,
      showCompareAppTypeStats,
      showCompareStatsForAllAppType,
    } = this.props;

    let eventTypes = [];

    let totalRegistrantNumber = 0;
    let totalCANumber = 0;
    let totalSourceRegistrantNumber = 0;
    let totalSourceCANumber = 0;

    if(auth.currentClient.businessType === 'SUPER_CHAIN') {
      eventTypes = [
        {legend: _('TRAININGS'), color: "#18A0FB", lineName: "formations"},
        {legend: _('CYCLES'), color: "#5F5DE8", lineName: "cycles"},
        {legend: _('CYCLES_ESSENTIAL'), color: "#14B7AD", lineName: "cycles_essential"},
        {legend: _('SEASONS'), color: "#F47F4D", lineName: "saisons"},
        {legend: _('MONTHLY_PREMIUM'), color: "#FB1E5B", lineName: "monthly_premium"},
        {legend: _('YEARLY_PREMIUM'), color: "#FFD433", lineName: "yearly_premium"},
        {legend: _('CONGRESS'), color: "#6D7F92", lineName: "congrès"},
      ];
    } else if(auth.currentClient.businessType === 'MASTER_CHAIN') {
      eventTypes = [
        {legend: _('TRAININGS'), color: "#18A0FB", lineName: "formations"},
        {legend: _('CYCLES'), color: "#5F5DE8", lineName: "cycles"},
      ];
    } else {
      eventTypes = [
        {legend: _('TRAININGS'), color: "#18A0FB", lineName: "formations"},
      ];
    }
    
   
    if (!fetching){
      eventTypes.forEach(({lineName}) => {
        
        if(chartLinesToShow.includes(lineName)){
          totalRegistrantNumber += this.calculateRegistrantsNumberByAppType(lineName, chartData);
          totalCANumber += this.calculateRegistrantsNumberByAppType(lineName, chartDataCA);
          
          if (sourceData) {
            totalSourceRegistrantNumber += this.calculateRegistrantsNumberByAppType(lineName, sourceData);
            totalSourceCANumber += this.calculateRegistrantsNumberByAppType(lineName, sourceDataCA);
          }
        }
      });
    }
   
    return (
      <div>
        {
          sourceData &&
          <Row className={'legend-row'}>
            <Col span={7}/>
            <Col span={8} className={'registrants-number flex justify-center'} style={{ justifyContent: "end", color: "#29394d", opacity: 0.7 }}>{year}</Col>
            <Col span={8} className={'registrants-number flex justify-center'} style={{ justifyContent: "end", color: "#29394d" }}>{sourceYear}</Col>
          </Row>
        }
        {
          <Row className={'legend-row'}>
            <Col span={sourceData ? 7 : 15}/>
            <Col span={4} className={'registrants-number flex'} style={{ paddingLeft: '20px', color: "#29394d", opacity: sourceData ? 0.7 : 1 }}>Inscriptions</Col>
            <Col span={4} className={'registrants-number flex justify-center'} style={{ justifyContent: "right", color: "#29394d", opacity: sourceData ? 0.7 : 1 }}>C.A</Col>
            {sourceData && <Col span={4} className={'registrants-number flex '} style={{ paddingLeft: '20px', color: "#29394d" }}>Inscriptions</Col>}
            {sourceData && <Col span={4} className={'registrants-number flex justify-center'} style={{ justifyContent: "right", color: "#29394d" }}>C.A</Col>}
        </Row>
        }
        {eventTypes.map(({legend, color, lineName}, index) => (
          <React.Fragment>
            <hr/>
            <EventLineChartLegendRow
              legend={legend}
              color={color}
              registrantNumber={fetching === false ? this.calculateRegistrantsNumberByAppType(lineName, chartData) : 0}
              caNumber={fetching === false ? this.calculateRegistrantsNumberByAppType(lineName, chartDataCA) : 0}
              updateChartLinesToShow={updateChartLinesToShow}
              chartLinesToShow={chartLinesToShow}
              fetching={fetching}
              isError={isError}
              lineName={lineName}
              sourceRegistrantNumber={fetching === false && sourceData ? this.calculateRegistrantsNumberByAppType(lineName, sourceData) : null }
              sourceCARegistrantNumber={fetching === false && sourceData ? this.calculateRegistrantsNumberByAppType(lineName, sourceDataCA) : null }
              type={type}
              startMonth={startMonth}
              endMonth={endMonth}
              sourceData={sourceData}
              chartData={chartData}
              frequency={frequency}
              showCompareStatsForAppType={this.props.showCompareStatsForAppType ? this.props.showCompareStatsForAppType : null}
              showCompareAppTypeStats={this.props.showCompareAppTypeStatsArray ? this.props.showCompareAppTypeStatsArray[lineName] : false}
              showCompareAppTypeStats2={showCompareAppTypeStats}
              dataPrevYearFetching={this.props.dataPrevYearFetching}
              CAdataPrevYearFetching={this.props.CAdataPrevYearFetching}
              showCompareStats={this.props.showCompareStats}
              activePremium={this.props.activePremium}
              activePremiumCurrentYear={this.props.activePremiumCurrentYear}
              activePremiumPreviousYear={this.props.activePremiumPreviousYear}
            />
            {index === eventTypes.length - 1 && <hr/>}
          </React.Fragment>
        ))}
        {
          fetching === false && 
          <Row className={'legend-row'} >
            <Col span={sourceData ? 5 : (((frequency === 'DAILY' && this.props.showCompareStats === false) || showCompareAppTypeStats) ? 10 : 15)} className={'registrants-number flex'} style={{color: "#29394d"}}>Total</Col>
            { sourceData && 
              <Col span={2} className={'registrants-number flex'} style={{marginLeft:"6px"}}>
              {
                Math.round((((totalSourceCANumber / 100) - (totalCANumber / 100)) / (totalCANumber / 100 == 0 ? 1 : totalCANumber / 100)) * 100) > 0
                ?
                <React.Fragment>
                  <img src="/img/icons/manage-BM/BM_plus.svg"/>
                  <span className={'ml-1'} style={{color: '#02af8e', fontSize: '12px'}}>{Math.abs(parseFloat(((((totalSourceCANumber / 100) - (totalCANumber / 100)) / (totalCANumber / 100 == 0 ? totalSourceCANumber / 100 : totalCANumber / 100)) * 100).toFixed(2)))}% </span>
                </React.Fragment>
                :
                <React.Fragment>
                  <img src="/img/icons/manage-BM/BM_moins.svg" className={'mr-1'}/>
                  <span className={'mr-1'} style={{color: '#fe3745', fontSize: '12px'}}>{Math.abs(parseFloat(((((totalSourceCANumber / 100) - (totalCANumber / 100)) / (totalCANumber / 100 == 0 ? totalSourceCANumber / 100 : totalCANumber / 100)) * 100).toFixed(2)))}% </span>
                </React.Fragment>
              }
            </Col>
            }
            
            { frequency === 'DAILY' && this.props.showCompareStats === false &&
            <Col span={5}>
              <Button 
                type="primary" 
                disabled={fetching} 
                onClick={() => showCompareStatsForAllAppType(this.props.compareAll)}
                style={{width: '100%', padding: 0}} 
                className={"compare-button " + (this.props.compareAll ? 'active-button' : '')}
              >
                {'Comparer tous'}
              </Button>
            </Col>
            }
            <Col span={4} className={'registrants-number flex'} style={{paddingLeft: '20px',color: "#29394d", opacity: sourceData ? 0.7 : 1}}>{formatNumber(totalRegistrantNumber)}</Col>
            <Col span={4} className={'registrants-number flex '} style={{justifyContent: "right", color: "#29394d", opacity: sourceData ? 0.7 : 1}}>{formatAmount(totalCANumber)}</Col>
            { sourceData && <Col span={4} className={'registrants-number flex'} style={{paddingLeft: '20px', color: "#29394d"}}>{formatNumber(totalSourceRegistrantNumber)}</Col> }
            { sourceData && <Col span={4} className={'registrants-number flex'} style={{justifyContent: "right",color: "#29394d"}}>{formatAmount(totalSourceCANumber)}</Col> }
            <Col span={1}/>
          </Row>
        }
      </div>
    );
  }
}







// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/EventLineChartLegend.js